import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import BaseApi from "./BaseApi";

const BASE_URL = "/open-api-key";

class OpenApi extends BaseApi{

    constructor() {
        super(BASE_URL);
    }

    public async getOpenApiAccountProfile(): Promise<AxiosResponse<any>> {
        return AxiosService.get(`${BASE_URL}/default`);
    }
}

export default OpenApi;